import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
var _excluded = ["columns", "isSelected", "toggleSelection", "toggleAll", "selectAll", "selectType", "selectWidth", "SelectAllInputComponent", "SelectInputComponent"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/* eslint-disable react/prop-types */
import React from 'react';
var noop = function noop() {};
var alwaysX = function alwaysX() {
  return 'x';
};
var generateInputOnClickEventHandler = function generateInputOnClickEventHandler(id, row, onClick) {
  return function (e) {
    var shiftKey = e.shiftKey;
    e.stopPropagation();
    onClick(id, shiftKey, row);
  };
};
var defaultSelectInputComponent = function defaultSelectInputComponent(_ref) {
  var selectType = _ref.selectType,
    checked = _ref.checked,
    id = _ref.id,
    row = _ref.row,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("input", {
    type: selectType || 'checkbox',
    checked: checked ? 'checked' : '',
    onClick: generateInputOnClickEventHandler(id, row, onClick),
    onChange: noop
  });
};

/*
extraColumnProps may be either an object or an function.
* object: the data will be used to extend the column object generated by this HOC.
* function: the generated column object data will be passed to the function along
  with the props like extraColumnProps(column, props). The returned object will
  be used as the new column as-is and will be prepended to the list of existing
  column array.

extra is an object with parameters that alter the HOC funcionality:
* prependColumn: function that takes two parameters: newColumn and original
  column array. should return a new array with the columns that are going to be
  used by the table.
 */
var selectTableHOC = function selectTableHOC() {
  var keyField = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '_id';
  var extraColumnProps = arguments.length > 1 ? arguments[1] : undefined;
  var extra = arguments.length > 2 ? arguments[2] : undefined;
  return function (Component) {
    var wrapper = /*#__PURE__*/function (_React$Component) {
      _inherits(RTSelectTable, _React$Component);
      var _super = _createSuper(RTSelectTable);
      function RTSelectTable(props) {
        var _this;
        _classCallCheck(this, RTSelectTable);
        _this = _super.call(this, props);
        _this.rowSelector = _this.rowSelector.bind(_assertThisInitialized(_this));
        _this.headSelector = _this.headSelector.bind(_assertThisInitialized(_this));
        _this.prependColumn = _this.prependColumn.bind(_assertThisInitialized(_this));
        _this.wrappedInstance = /*#__PURE__*/React.createRef();
        return _this;
      }
      _createClass(RTSelectTable, [{
        key: "rowSelector",
        value: function rowSelector(row) {
          if (!row || !row.hasOwnProperty(keyField)) return null; // eslint-disable-line no-prototype-builtins
          var _this$props = this.props,
            toggleSelection = _this$props.toggleSelection,
            selectType = _this$props.selectType,
            SelectInputComponent = _this$props.SelectInputComponent,
            isSelected = _this$props.isSelected;
          var checked = isSelected(row[keyField]);
          var inputProps = {
            checked: checked,
            onClick: toggleSelection,
            selectType: selectType,
            id: row[keyField],
            row: row
          };
          return /*#__PURE__*/React.createElement(SelectInputComponent, inputProps);
        }

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      }, {
        key: "headSelector",
        value: function headSelector(row) {
          var _this$props2 = this.props,
            selectType = _this$props2.selectType,
            toggleAll = _this$props2.toggleAll;
          if (selectType === 'radio' || !toggleAll) return null;
          var _this$props3 = this.props,
            checked = _this$props3.selectAll,
            SelectAllInputComponent = _this$props3.SelectAllInputComponent;
          var inputProps = {
            checked: checked,
            onClick: toggleAll,
            selectType: selectType
          };
          return /*#__PURE__*/React.createElement(SelectAllInputComponent, inputProps);
        }

        // this is so we can expose the underlying ReactTable to get at the sortedData for selectAll
      }, {
        key: "getWrappedInstance",
        value: function getWrappedInstance() {
          if (!this.wrappedInstance.current) console.warn('RTSelectTable - No wrapped instance');
          return this.wrappedInstance.current && this.wrappedInstance.current.getWrappedInstance ? this.wrappedInstance.current.getWrappedInstance() : this.wrappedInstance.current;
        }
      }, {
        key: "prependColumn",
        value: function prependColumn(selectColumn, columnArray) {
          if (extra && extra.prependColumn) {
            return extra.prependColumn(selectColumn, columnArray);
          }
          return [selectColumn].concat(_toConsumableArray(columnArray));
        }
      }, {
        key: "render",
        value: function render() {
          var _this2 = this;
          var _this$props4 = this.props,
            originalCols = _this$props4.columns,
            isSelected = _this$props4.isSelected,
            toggleSelection = _this$props4.toggleSelection,
            toggleAll = _this$props4.toggleAll,
            selectAll = _this$props4.selectAll,
            selectType = _this$props4.selectType,
            selectWidth = _this$props4.selectWidth,
            SelectAllInputComponent = _this$props4.SelectAllInputComponent,
            SelectInputComponent = _this$props4.SelectInputComponent,
            rest = _objectWithoutProperties(_this$props4, _excluded);
          var select = {
            id: '_selector',
            accessor: alwaysX,
            // this value is not important
            Header: this.headSelector,
            Cell: function Cell(ci) {
              return _this2.rowSelector(ci.original);
            },
            width: selectWidth || 30,
            filterable: false,
            sortable: false,
            resizable: false,
            style: {
              textAlign: 'center'
            }
          };
          var selectColumn = select;
          if (extraColumnProps) {
            if (_typeof(extraColumnProps) === 'object') {
              Object.assign(selectColumn, extraColumnProps);
            } else if (typeof extraColumnProps === 'function') {
              selectColumn = extraColumnProps(select, this.props);
            } else {
              console.warn('invalid extraColumnProps argument type passed to selectTableHOC:', _typeof(extraColumnProps));
            }
          }
          var columns = this.prependColumn(selectColumn, originalCols);
          var extra = {
            columns: columns
          };
          return /*#__PURE__*/React.createElement(Component, _extends({}, rest, extra, {
            ref: this.wrappedInstance
          }));
        }
      }]);
      return RTSelectTable;
    }(React.Component);
    wrapper.displayName = 'RTSelectTable';
    wrapper.defaultProps = {
      isSelected: function isSelected(key) {
        console.warn('No isSelected handler provided:', {
          key: key
        });
      },
      selectAll: false,
      toggleSelection: function toggleSelection(key, shift, row) {
        console.warn('No toggleSelection handler provided:', {
          key: key,
          shift: shift,
          row: row
        });
      },
      selectType: 'checkbox',
      SelectInputComponent: defaultSelectInputComponent,
      SelectAllInputComponent: defaultSelectInputComponent
    };
    return wrapper;
  };
};
export default selectTableHOC;